"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.resultMessages = exports.Result = void 0;
const schema_1 = require("../../../../schema");
var Result;
(function (Result) {
    Result["POSITIVE"] = "POSITIVE";
    Result["NEGATIVE"] = "NEGATIVE";
})(Result || (exports.Result = Result = {}));
exports.resultMessages = {
    [Result.POSITIVE]: {
        id: "ktx.transplantationScreening.labProcedures.stoolculture.result.POSITIVE",
        defaultMessage: "Pozitív"
    },
    [Result.NEGATIVE]: {
        id: "ktx.transplantationScreening.labProcedures.stoolculture.result.NEGATIVE",
        defaultMessage: "Negatív"
    }
};
const result = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Result.POSITIVE),
    schema_1.Schema.singleChoiceItem(Result.NEGATIVE)
]);
exports.validator = schema_1.Schema.object()
    .expiration(31536000)
    .default({})
    .sealed(true)
    .properties({ result })
    .interpretation({ vocab: "ktx", code: "lab_stool_culture" })
    .tag({ vocab: "snomed", code: "117028002", source: "synonym" })
    .tag({ vocab: "ktx", code: "lab_procedure" });
